import { NgModule } from '@angular/core';
import { FeaturesCommonModule } from 'src/app/features-common/features-common.module';
import { AgGridModule } from 'ag-grid-angular';
import { ProviderRoutingModule } from './providers-routing.module';
import { ProvidersComponent } from './providers.component';
import { AddProviderComponent } from './add-provider/add-provider.component';
import { AllProvidersComponent } from './all-providers/all-providers.component';
import { ProvidersService } from './providers.service';
import { EditProviderComponent } from './edit-provider/edit-provider.component';

import { RetailerPricelistComponent } from './manage-commission/retailer-pricelist/retailer-pricelist.component';
import { PricelistComponent } from './manage-commission/retailer-pricelist/pricelist/pricelist.component';
import { UpdatePricelistComponent } from './manage-commission/retailer-pricelist/update-pricelist/update-pricelist.component';
import { UpdatePricelistSmartComponent } from './manage-commission/retailer-pricelist/update-pricelist/update-pricelist-smart.component';
import { CreatePricelistComponent } from './manage-commission/retailer-pricelist/create-pricelist/create-pricelist.component';
import { BulkUpdatePricelistComponent } from './manage-commission/retailer-pricelist/bulk-update-pricelist/bulk-update-pricelist.component';

import { SalesPricelistComponent } from './manage-commission/sales-pricelist/sales-pricelist.component';
import { SalesrepsPricelistComponent } from './manage-commission/sales-pricelist/salesreps-pricelist/salesreps-pricelist.component';
import { SalesrepsBulkUpdatePricelistComponent } from './manage-commission/sales-pricelist/salesreps-bulk-update-pricelist/salesreps-bulk-update-pricelist.component';
import { SalesrepsCreatePricelistComponent } from './manage-commission/sales-pricelist/salesreps-create-pricelist/salesreps-create-pricelist.component';
import { SalesrepsUpdatePricelistComponent } from './manage-commission/sales-pricelist/salesreps-update-pricelist/salesreps-update-pricelist.component';
import { SalesrepsUpdatePricelistSmartComponent } from './manage-commission/sales-pricelist/salesreps-update-pricelist/salesreps-update-pricelist-smart.component';
import { RetailerImportComponent } from './manage-commission/retailer-pricelist/retailer-import/retailer-import.component';
import { SalesrepsImportComponent } from './manage-commission/sales-pricelist/salesreps-import/salesreps-import.component';
import { MapPricelistComponent } from './map-pricelist/map-pricelist.component';
import { MapPricelistSmartComponent } from './map-pricelist/map-pricelist-smart.component';
import { AllPricelistsComponent } from './update-pricelist/all-pricelists/all-pricelists.component';
import { UpdatePricelistsComponent } from './update-pricelist/update-pricelists/update-pricelists.component';
import { UpdateAllPricelistComponent } from './update-pricelist/update-pricelist.component';
import { ConsumerPricelistComponent } from './manage-commission/consumer-pricelist/consumer-pricelist.component';
import { ConsumerImportComponent } from './manage-commission/consumer-pricelist/consumer-import/consumer-import.component';
import { ConsumerAllPricelistComponent } from './manage-commission/consumer-pricelist/consumer-all-pricelist/consumer-all-pricelist.component';
import { ConsumerUpdatePricelistComponent } from './manage-commission/consumer-pricelist/consumer-update-pricelist/consumer-update-pricelist.component';
import { UpdateConsumerPricelistSmartComponent } from './manage-commission/consumer-pricelist/consumer-update-pricelist/consumer-update-pricelist-smart.component';


@NgModule({
  declarations: [
    ProvidersComponent, 
    RetailerPricelistComponent,
    PricelistComponent,
    SalesPricelistComponent,
    SalesrepsPricelistComponent,
    SalesrepsBulkUpdatePricelistComponent,
    SalesrepsCreatePricelistComponent,
    SalesrepsUpdatePricelistComponent,
    SalesrepsUpdatePricelistSmartComponent,
    AddProviderComponent, 
    AllProvidersComponent, 
    CreatePricelistComponent, 
    BulkUpdatePricelistComponent, 
    UpdatePricelistComponent, 
    UpdateAllPricelistComponent,
    UpdatePricelistSmartComponent,
    EditProviderComponent,
    RetailerImportComponent,
    SalesrepsImportComponent,
    MapPricelistComponent,
	  MapPricelistSmartComponent,
	  AllPricelistsComponent,
	  UpdatePricelistsComponent,
	  ConsumerPricelistComponent,
	  ConsumerImportComponent,
	  ConsumerAllPricelistComponent,
	  ConsumerUpdatePricelistComponent,
    UpdateConsumerPricelistSmartComponent
  ],
  imports: [
    FeaturesCommonModule,
    ProviderRoutingModule,
    AgGridModule.withComponents([]),
  ],
  exports: [
    ProvidersComponent, 
    RetailerPricelistComponent, 
	  PricelistComponent,
    MapPricelistComponent,
    MapPricelistSmartComponent,
    SalesPricelistComponent, 
    SalesrepsPricelistComponent,
    SalesrepsBulkUpdatePricelistComponent,
    SalesrepsCreatePricelistComponent,
    SalesrepsUpdatePricelistComponent,
    SalesrepsUpdatePricelistSmartComponent,    
    AddProviderComponent, 
    EditProviderComponent,
    AllProvidersComponent, 
    CreatePricelistComponent, 
    BulkUpdatePricelistComponent,
    UpdateAllPricelistComponent,
    UpdatePricelistSmartComponent,
    UpdatePricelistComponent,
    RetailerImportComponent,
    SalesrepsImportComponent
  ],
  providers: [ ProvidersService
  ]
})
export class ProvidersModule { }
